export const RUN_USER_LOGIN 	 =        'RUN_USER_LOGIN'
export const RUN_USER_LOGIN_2FA  =        'RUN_USER_LOGIN_2FA'
export const RUN_GENERATE_2FA_QRCODE = 	  'RUN_GENERATE_2FA_QRCODE'
export const RUN_VERIFY_2FA_QRCODE	 = 	  'RUN_VERIFY_2FA_QRCODE'
export const RUN_DISABLE_2FA_QRCODE	 = 	  'RUN_DISABLE_2FA_QRCODE'
export const RUN_STATE_LOAD 	 = 		  'RUN_STATE_LOAD'
export const RUN_USER_LOGOUT 	 = 		  'RUN_USER_LOGOUT'
export const SAVE_FIREBASE_TOKEN = 	      'SAVE_FIREBASE_TOKEN'
/* ************** getters ***********************/
export const GET_INFO = 'GET_INFO'
export const GET_TOKEN = 'GET_TOKEN'
export const GET_USER = 'GET_USER'
export const GET_LOADERS = 'GET_LOADERS'
export const GET_USER_LIST = 'GET_USER_LIST'
export const GET_QUESTIONS = 'GET_QUESTIONS'


/* ************** mutations - setters ***********************/
export const SET_INFO = 'SET_INFO'
export const SET_STATE = 'SET_STATE'
export const SET_STATE_PERSIST_LOCAL = 'SET_STATE_PERSIST_LOCAL'
export const SET_TOGGLE_LOADER = 'SET_TOGGLE_LOADER'
export const SET_STATE_USER_LIST = "SET_STATE_USER_LIST"
export const SET_QUESTIONS = "SET_QUESTIONS"


// WEBPACK FOOTER //
// ./src/types.js